import { QuestionCircleTwoTone } from '@ant-design/icons'
import { Space, Tooltip, Popover } from 'antd'
import { HelpIconProps } from './types'

/**
 * adds a help icon to the right of any child components
 *
 * @param props {@link HelpIconProps}
 * @example
 * <HelpIcon text="Some helpful information to explain the text">
 *  Some text that needs explaining
 * </HelpIcon>
 */
const HelpIcon: React.FC<HelpIconProps> = ({ children, text }) => {
  if (!text) return <>{children}</>
  return (
    <Space size="small" style={{ cursor: 'unset' }}>
      {children}
      {typeof text === 'string' ? (
        <Tooltip title={text} trigger="hover">
          <QuestionCircleTwoTone style={{ cursor: 'help' }} />
        </Tooltip>
      ) : (
        <Popover title={text.title} content={text.content} trigger="hover">
          <QuestionCircleTwoTone style={{ cursor: 'help' }} />
        </Popover>
      )}
    </Space>
  )
}

export default HelpIcon
